module.exports = "<div class=\"basic-container\">\n    <div class=\"text-container\">\n    </div>\n</div>"